import { SafeSuspense } from '@calendly/safe-suspense'
import { lazy, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import LoadingState from 'components/core/loading_state'
import { CONTENT_PAGES } from 'features/empty_state'
import { UpgradeBanner } from 'features/upgrade_banner'
import { useDebounce } from 'hooks/useDebounce'

import { userGroupsParamsSelector } from './selectors'
import { setDefaultPage, fetchUserGroups } from './slice'
import { isUserGroupsEnabledSelector } from '../slice'

const Content = lazy(async () => {
  const loaded = await import(/* webpackChunkName: 'userGroups' */'./content')
  return { default: loaded.Content }
})

export const List = () => {
  const dispatch = useDispatch()
  const allParams = useSelector(userGroupsParamsSelector)
  const { filter_term: filterTerm, page, sort_field: sortField, sort_order: sortOrder } = allParams
  const debouncedFilterTerm = useDebounce(filterTerm, 300)
  const isUserGroupsEnabled = useSelector(isUserGroupsEnabledSelector)

  const stableParams = useMemo(() => ({
    page,
    sort_field: sortField,
    sort_order: sortOrder
  }), [page, sortField, sortOrder])

  useEffect(() => {
    if (stableParams.page) {
      dispatch(fetchUserGroups())
    } else {
      dispatch(setDefaultPage())
    }
  }, [
    dispatch,
    debouncedFilterTerm,
    stableParams.page,
    stableParams.sort_field
  ])

  return (
    <>
      {!isUserGroupsEnabled && <UpgradeBanner featureKey="user_groups" contentKey={CONTENT_PAGES.groups} />}
      <SafeSuspense fallback={<LoadingState />}>
        <Content />
      </SafeSuspense>
    </>
  )
}
